import { jsx as _jsx } from "react/jsx-runtime";
import { Footer } from '@at/design-system-patterns';
import { useTrackFooterLogic } from '../logic/connected-footer.utils';
// ConnectedFooter component that integrates Footer with tracking logic
export const ConnectedFooter = (props) => {
    const trackingCallbacks = useTrackFooterLogic();
    return _jsx(Footer, Object.assign({ trackingCallbacks: trackingCallbacks }, props));
};
